export default [
  {
    path: '/poc/:key?',
    name: 'pocPage',
    component: () => import('@/views/poc/PocIndex.vue'),
    meta: {},
  },
];
